import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import apiInstanceV2 from '../../Apis/AxiosV2';
import { UploadImage } from '../ShareSlice/shareApi';
import { MODELS } from '../../Apis/Models';
import { TABLES } from '../../Apis/Tables';
const serviceName = 'foodie-menu-service';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

//foodie-menu-service/v1/diet-types/get-all
export const GetDietTypes = createAsyncThunk('dish/GetDietTypes ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/diet-types/get-all`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
//foodie-menu-service/v1/allergens/get-all
export const GetAllAllergens = createAsyncThunk('dish/GetAllAllergens', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/allergens/get-all`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
//foodie-menu-service/v1/ingredients/get-all
export const GetAllIngredients = createAsyncThunk('dish/GetAllIngredients', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/ingredients/get-all`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
//foodie-menu-service/v1/items/{id}
export const GetDishById = createAsyncThunk('dish/GetDishById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/items/${params}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
//foodie-menu-service/v1/items/create
export const CreateDish = createAsyncThunk('dish/CreateDish', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(`${serviceName}/v1/items/create`, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
//foodie-menu-service/v1/items/update
export const UpdateDish = createAsyncThunk('dish/UpdateDish', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .put(`${serviceName}/v1/items/update`, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
export const CreateDishImage = createAsyncThunk(`dish/CreateDishImage`, async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .post(`${serviceName}/v1/items/image/create`, params?.imgData)
        .then(function (response) {
            // this api need id, file and option
            let formData = new FormData();
            formData.append('id', response?.data?.data?.id);
            formData.append('option', TABLES.DISH);
            formData.append('file', params?.image);
            dispatch(UploadImage(formData));
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status, code } = result;

    return { data, status, code };
});

export const GetDishImageByDishId = createAsyncThunk(
    'dish/GetDishImageByDishId',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`${serviceName}/v1/foodie_item/image/by-id/${params}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
